import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-md-3 mb-2" }
const _hoisted_5 = { class: "col-md-2 mb-2" }
const _hoisted_6 = { class: "col-md-2 mb-2" }
const _hoisted_7 = { class: "col-md-3 mb-2" }
const _hoisted_8 = {
  class: "position-relative mt-2 p-2 bg-white shadow rounded",
  style: {"z-index":"999"}
}
const _hoisted_9 = { class: "col-md-2 d-flex align-items-end mb-2" }
const _hoisted_10 = { class: "d-lg-flex align-items-center justify-content-between" }
const _hoisted_11 = { class: "d-sm-flex align-items-center" }
const _hoisted_12 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_15 = { class: "shadow-none fw-medium text-black title ps-0" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = {
  key: 0,
  class: "badge bg-outline-danger"
}
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = {
  key: 0,
  class: "badge text-bg-success rounded-pill"
}
const _hoisted_24 = {
  key: 1,
  class: "badge text-bg-warning rounded-pill"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-paragraph text-end pe-0" }
const _hoisted_27 = { class: "dropdown" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_32 = { class: "mb-0 text-paragraph" }
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = { class: "mt-15 mt-md-0" }
const _hoisted_37 = { class: "pagination mb-0" }
const _hoisted_38 = {
  key: 0,
  class: "page-item"
}
const _hoisted_39 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 2,
  class: "page-item disabled"
}
const _hoisted_42 = {
  key: 3,
  class: "page-item"
}
const _hoisted_43 = {
  class: "modal fade",
  id: "archiveModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-lg" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-body" }
const _hoisted_47 = { class: "table table-responsive mb-0" }
const _hoisted_48 = { class: "text-nowrap" }
const _hoisted_49 = { class: "text-nowrap" }
const _hoisted_50 = { class: "text-nowrap" }
const _hoisted_51 = { class: "text-nowrap" }
const _hoisted_52 = {
  key: 0,
  class: "badge text-bg-danger rounded-pill fs-13"
}
const _hoisted_53 = {
  key: 1,
  class: "badge text-bg-success rounded-pill fs-13"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Magasin :", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              modelValue: _ctx.client_filter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client_filter) = $event)),
              label: "name",
              options: _ctx.clientList,
              onSearch: _ctx.filterClients
            }, null, 8, ["modelValue", "options", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Agence :", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              modelValue: _ctx.agency_filter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agency_filter) = $event)),
              label: "name",
              options: _ctx.agenciesList
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Statut :", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status_filter) = $event)),
              class: "form-select"
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("option", {
                value: "",
                selected: ""
              }, "Status (Tous)", -1),
              _createElementVNode("option", { value: "0" }, "Pas encore reçu", -1),
              _createElementVNode("option", { value: "1" }, "Réçu", -1)
            ]), 512), [
              [_vModelSelect, _ctx.status_filter]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label" }, "Date de création:", -1)),
            _createElementVNode("div", {
              class: "border p-2 cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCalendar()))
            }, [
              _createTextVNode(_toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "—") + " - " + _toDisplayString(_ctx.selectedDate?.[1]?.format("DD MMM YYYY") || "—") + " ", 1),
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-calendar float-end" }, null, -1))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createVNode(_component_MyDateRangePicker, {
                modelValue: _ctx.selectedDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
                onOnSelect: _ctx.showCalendar,
                enableSecondCalendar: true
              }, null, 8, ["modelValue", "onOnSelect"])
            ], 512), [
              [_vShow, _ctx.showCalendarBox]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary me-2",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args)))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("i", { class: "flaticon-search" }, null, -1)
            ])),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args)))
            }, _cache[18] || (_cache[18] = [
              _createElementVNode("i", { class: "flaticon-close" }, null, -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.auth.can('STOCK'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/add-product",
                  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode(" Nouveau Produit ", -1),
                    _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                  ])),
                  _: 1,
                  __: [19]
                }))
              : _createCommentVNode("", true)
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
            _createElementVNode("form", { class: "search-box position-relative" }, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none text-black rounded-0 border-0",
                placeholder: "Search lead"
              })
            ])
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                }, " Produit "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Magasin "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Agence "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Quantité "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Statut "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date de réception "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("th", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("b", null, [
                        _createElementVNode("img", {
                          src: row.pic,
                          class: "me-15",
                          width: "44"
                        }, null, 8, _hoisted_17),
                        _createTextVNode(" " + _toDisplayString(row?.name) + " ", 1),
                        _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(row.customer_name), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(row.stock_agency_name), 1),
                  _createElementVNode("td", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.inventories, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: item.id
                      }, [
                        _createVNode(_component_center, null, {
                          default: _withCtx(() => [
                            _createElementVNode("b", null, _toDisplayString(item.inventory_ref), 1),
                            _createTextVNode(" " + _toDisplayString(item.qty) + " | " + _toDisplayString(item.qty_not_received) + " ", 1),
                            (item.archived == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Archivé "))
                              : _createCommentVNode("", true),
                            _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1))
                          ]),
                          _: 2,
                          __: [22]
                        }, 1024)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    (row.received == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Reçu "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, " Pas encore reçu "))
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    (row.received_time)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(row.received_time)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[25] || (_cache[25] = _createElementVNode("button", {
                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "flaticon-dots" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_28, [
                        _createElementVNode("li", null, [
                          (_ctx.auth.can('STOCK'))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item d-flex align-items-center",
                                onClick: _withModifiers(($event: any) => (
                          _ctx.$router.push({
                            name: 'EditProductPage',
                            params: { id: row.id },
                          })
                        ), ["prevent"])
                              }, _cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier", -1)
                              ]), 8, _hoisted_29))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("li", null, [
                          (_ctx.auth.can('STOCK'))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.archiveProduct(row))
                              }, _cache[24] || (_cache[24] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Archiver", -1)
                              ]), 8, _hoisted_30))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("p", _hoisted_32, [
            _cache[27] || (_cache[27] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_33, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[28] || (_cache[28] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_34, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[29] || (_cache[29] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.filter.total), 1),
            _cache[30] || (_cache[30] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", _hoisted_36, [
            _createElementVNode("ul", _hoisted_37, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Previous",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
                }, " ‹ ")
              ], 2),
              (_ctx.pages[0] !== 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage(1)))
                    }, "1")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pages[0] > 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_39, _cache[31] || (_cache[31] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ])))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: "page-item"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_40)
                ]))
              }), 128)),
              (_ctx.pages[_ctx.pages.length - 1] < _ctx.filter.last_page - 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_41, _cache[32] || (_cache[32] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ])))
                : _createCommentVNode("", true),
              (_ctx.pages[_ctx.pages.length - 1] !== _ctx.filter.last_page)
                ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage(_ctx.filter.last_page)))
                    }, _toDisplayString(_ctx.filter.last_page), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Next",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
                }, " › ")
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Archivation des produits"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("table", _hoisted_47, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: field.key
                    }, _toDisplayString(field.label || field.key), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventoriesRow, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_48, _toDisplayString(row.inventory_ref), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(row.qty), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(row.qty_not_received), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_51, [
                        (row.archived == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, " Archivé "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_53, " Activé "))
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      (row.archived == 0 && (row.qty == 0 || row.qty < 0))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-danger",
                            title: "Archiver La variante",
                            onClick: ($event: any) => (_ctx.$emit('archiveVariant', row))
                          }, _cache[33] || (_cache[33] = [
                            _createElementVNode("i", { class: "flaticon-check-mark lh-1 me-8 position-relative top-1" }, null, -1)
                          ]), 8, _hoisted_54))
                        : _createCommentVNode("", true),
                      (row.archived == 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-success",
                            title: "Désarchiver La variante",
                            onClick: ($event: any) => (_ctx.$emit('archiveVariant', row))
                          }, _cache[34] || (_cache[34] = [
                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
                          ]), 8, _hoisted_55))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}